import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import PublicHeader from "../../components/PublicHeader/PublicHeader";
import "./BookDemo.css";

const CALCOM_EMBED_LINK = process.env.REACT_APP_CALCOM_EMBED_LINK || "teamgrid-sales-bd6ovp/30min";
const CALCOM_BOOKING_URL = `https://cal.com/${CALCOM_EMBED_LINK}`;

const BookDemo = () => {
  const [iframeLoaded, setIframeLoaded] = useState(false);

  return (
    <>
      <Helmet>
        <title>Book a Demo | TeamGrid</title>
        <meta name="description" content="Schedule a live demo of TeamGrid. See AI-powered workforce intelligence and productivity insights in action." />
        <link rel="canonical" href="https://teamgrid.ai/book-demo" />
      </Helmet>
      <div className="book-demo-page">
      <PublicHeader />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
      {/* Hero */}
      <section className="book-demo-hero">
        <h1 className="book-demo-title">
          Book Your <span className="book-demo-title-accent">Live Demo</span>
        </h1>
        <p className="book-demo-subtitle">
          See TeamGrid in action. Get a personalized walkthrough and all your questions answered.
        </p>
      </section>

      {/* Main: Calendar + Right cards */}
      <section className="book-demo-section">
        <div className="book-demo-main">
          {/* Left: Cal.com embed (iframe to avoid cross-origin script errors) */}
          <div className="book-demo-calendar-card">
            {!iframeLoaded && (
              <div className="book-demo-calendar-loading" aria-hidden="true">
                <img src="/logo-dark.svg" alt="TeamGrid" className="book-demo-calendar-loading-logo" />
                <div className="book-demo-calendar-loading-spinner" />
              </div>
            )}
            <iframe
              title="Book a demo with TeamGrid"
              src={CALCOM_BOOKING_URL}
              className="book-demo-cal-embed"
              style={{ opacity: iframeLoaded ? 1 : 0 }}
              onLoad={() => setIframeLoaded(true)}
            />
          </div>

          {/* Right: Demo Details + What You'll See */}
          <div className="book-demo-right">
            <div className="book-demo-info-card">
              <div className="book-demo-info-card-header">
                <img src="/demo_1.webp" alt="Demo details" className="book-demo-icon-img" />
                <h3 className="book-demo-info-card-title">Demo Details</h3>
              </div>
              <ul className="book-demo-details-list">
                <li>
                  <img src="/demo_2.webp" alt="30-minute session" className="book-demo-list-icon-img" />
                  <span>30-minute live session</span>
                </li>
                <li>
                  <img src="/demo_3.webp" alt="Video call" className="book-demo-list-icon-img" />
                  <span>Video call via Zoom or Google Meet</span>
                </li>
                <li>
                  <img src="/demo_4.webp" alt="Personalized demo" className="book-demo-list-icon-img" />
                  <span>Personalized to your use case</span>
                </li>
                <li>
                  <img src="/demo_5.webp" alt="Q&A" className="book-demo-list-icon-img" />
                  <span>Q&A about your specific needs</span>
                </li>
              </ul>
            </div>

            <div className="book-demo-info-card book-demo-info-card-what">
              <h3 className="book-demo-info-card-title">What You'll See</h3>
              <ul className="book-demo-see-list">
                <li><span className="book-demo-dot" /> Live dashboard walkthrough</li>
                <li><span className="book-demo-dot" /> AI insight generation in action</li>
                <li><span className="book-demo-dot" /> Team analytics and reports</li>
                <li><span className="book-demo-dot" /> Privacy settings and controls</li>
                <li><span className="book-demo-dot" /> Integration possibilities</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      </div>

      {/* Bottom footer */}
      <footer
        className="book-demo-footer"
        style={{ borderTopColor: "rgba(0, 0, 0, 0.2)", fontFamily: "Inter, sans-serif" }}
      >
        <div className="book-demo-footer-inner">
          <a href="/security" className="book-demo-footer-link">Security</a>
          <a href="/privacy-policy" className="book-demo-footer-link">Privacy</a>
          <a href="/terms" className="book-demo-footer-link">Terms</a>
          <a href="/contact-us" className="book-demo-footer-link">Contact</a>
          <span className="book-demo-footer-copy">© 2026 TeamGrid</span>
        </div>
      </footer>
    </div>
    </>
  );
};

export default BookDemo;
